module.exports = __webpack_public_path__ + "img/구름많고한때비.b63ac5d9.png";